/* CupCus — giữ món bán kèm đi cùng tranh trong giỏ.
   Tranh và món kèm có chung property _cc_link. Món kèm luôn có số lượng = số lượng tranh;
   xoá tranh → món kèm về 0 (không để khách trả tiền nâng cấp mà không có tranh).
   Chạy khi giỏ thay đổi (drawer vẽ lại) và khi tải trang. */
(function () {
  var busy = false, timer = null;

  function isMain(it) { return it.properties && it.properties._cc_link && !it.properties.For; }
  function isAddon(it) { return it.properties && it.properties._cc_link && it.properties.For; }

  function renderDrawer(sections) {
    if (!sections) return;
    [['Cart-Drawer', 'cart-drawer', '.cart-drawer'], ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']].forEach(function (s) {
      var host = document.getElementById(s[0]);
      if (!host || !sections[s[1]]) return;
      var target = host.querySelector(s[2]) || host;
      var src = new DOMParser().parseFromString(sections[s[1]], 'text/html').querySelector(s[2]);
      if (src) target.innerHTML = src.innerHTML;
    });
    if (typeof CartDrawer !== 'undefined') new CartDrawer();
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = {}, updates = {}, need = false;
        cart.items.forEach(function (it) { if (isMain(it)) qty[it.properties._cc_link] = (qty[it.properties._cc_link] || 0) + it.quantity; });
        cart.items.forEach(function (it) {
          if (!isAddon(it)) return;
          var want = qty[it.properties._cc_link] || 0;
          if (it.quantity !== want) { updates[it.key] = want; need = true; }
        });
        if (!need) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-bubble', sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (location.pathname === '/cart') { location.reload(); return; }
          renderDrawer(res.sections);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    if (!document.querySelector('.cc-line-prop')) return;   // giỏ không có món kèm → không gọi máy chủ
    clearTimeout(timer); timer = setTimeout(reconcile, 350);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.documentElement.hasAttribute('data-cc-linked')) reconcile();   // giỏ đang có món kèm (Liquid đánh dấu)
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    var page = document.querySelector('.thb-cart-form');
    if (page) new MutationObserver(schedule).observe(page, { childList: true, subtree: true });
  });
})();
